export default __webpack_public_path__ + "static/media/arrow-back.167d98a2.svg";